var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('multi-select',{attrs:{"options":_vm.foundItems,"label":"name","trackBy":"id","multiple":true},model:{value:(_vm.selectedItems),callback:function ($$v) {_vm.selectedItems=$$v},expression:"selectedItems"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }